import React, {useState} from 'react';
import {
  IconLocation,
  IconUser,
  // IconCheck,
  // IconChevronLeft,
  // IconChevronRight,
  // IconSpinner,
} from "../../../../../components/icons";
import {useFormik} from "formik";
import {Depositaire} from "../../../../../components/models";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import {createDepositaire, updateDepositaire} from "../../../../../components/requests";

interface DepositaireProps {
  nom?: string;
  ville?: string;
  cp?: string;
  code?: string;
  departement?: string;
}

type DepositaireErrors = Partial<Record<keyof DepositaireProps, string>>;

const validate = (values: DepositaireProps): DepositaireErrors => {
  const errors: DepositaireErrors = {};

  if (!values.nom || values.nom.trim().length === 0) {
    errors.nom = 'Ce champ est requis';
  }
  if (!values.cp) {
    errors.cp = 'Ce champ est requis';
  }
  if (!values.ville) {
    errors.ville = 'Ce champ est requis';
  }

  return errors;
};

const DepositaireForm = (
  {
    depositaire = null,
    setDepositaire = null,
    // setIsActive = null
  }: {
    depositaire?: Depositaire | null,
    setDepositaire?: any | null,
    // setIsActive?: any | null,
  }) => {
  const {id} = useParams();
  const [depositaireId, setDepositaireId] = useState<number | null>(null);
  // const [isValideLoading, setIsValideLoading] = useState<boolean>(false);
  // const [isBrouillonLoading, setIsBrouillonLoading] = useState<boolean>(false);
  // const [isBrouillon, setIsBrouillon] = useState<boolean | null>(null);

  const formik = useFormik({
    initialValues: {
      nom: depositaire ? depositaire.nom : '',
      ville: depositaire ? depositaire.ville : '',
      cp: depositaire ? depositaire.cp : '',
      code: depositaire ? depositaire.code : '',
      departement: depositaire ? depositaire.departement : '',
    },
    enableReinitialize: true,
    validate,
    onSubmit: (values: DepositaireProps) => {
      // if (isBrouillon) setIsBrouillonLoading(true)
      // else setIsValideLoading(true);

      let payload = {
        nom: values.nom,
        ville: values.ville,
        cp: values.cp,
        code: values.code,
        departement: values.departement,
        // brouillon: isBrouillon,
        ...((!depositaire) ? {dossier: `api/dossiers/${id}`} : {})
      };

      const method = (!depositaire) ? createDepositaire(payload) : updateDepositaire((depositaire.id) ? depositaire.id : depositaireId, payload)
      method
        .then((response) => {
          if ((response.status === 200 || response.status === 201) && response.data !== undefined) {
            setDepositaire({
              ...((!depositaire) ? {} : {id: depositaire.id}),
              nom: payload.nom,
              ville: payload.ville,
              cp: payload.cp,
              code: payload.code,
              departement: payload.departement,
              // brouillon: payload.brouillon,
            })
            if (!depositaire) setDepositaireId(response.data['@id'].split('/').pop())
            toast.success(`Dépositaire ${(!depositaire) ? 'créé' : 'modifié'}`);
          }
        })
        .catch((error) => console.error(error))
        .finally(() => {
          // if (isBrouillon) setIsBrouillonLoading(false)
          // else setIsValideLoading(false);
        })
    },
  });

  return (
    <>
      {/*<form onSubmit={formik.handleSubmit}>*/}
      <div className="p-4 animate-in fade-in duration-300">
        <div className="grid grid-cols-2 gap-4">
          <div className="section-card">
            <div className="section-header">
              <div className="section-icon bg-blue-100 text-blue-600">
                <IconUser/>
              </div>
              <span className="section-title">Identification</span></div>
            <div className="section-body grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <label className="form-label">Nom</label>
                <input
                  name="nom"
                  type="text"
                  className="form-input font-mono uppercase hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nom}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.nom ? <div className="text-xs text-red-600">
                  {formik.errors.nom}
                </div> : null}
              </div>
              {/*<div className="col-span-2">*/}
              {/*  <label className="form-label">Code</label>*/}
              {/*  <input*/}
              {/*    name="code"*/}
              {/*    type="text"*/}
              {/*    className="form-input font-mono uppercase hover:cursor-not-allowed"*/}
              {/*    onChange={formik.handleChange}*/}
              {/*    onBlur={formik.handleBlur}*/}
              {/*    value={formik.values.code}*/}
              {/*    disabled={true}*/}
              {/*    readOnly={true}*/}
              {/*  />*/}
              {/*  {formik.errors.code ? <div className="text-xs text-red-600">*/}
              {/*    {formik.errors.code}*/}
              {/*  </div> : null}*/}
              {/*</div>*/}
            </div>
          </div>
          <div className="section-card">
            <div className="section-header">
              <div className="section-icon bg-purple-100 text-purple-600">
                <IconLocation/>
              </div>
              <span className="section-title">Localisation</span>
            </div>
            <div className="section-body grid grid-cols-2 gap-3">
              {/*<div className="col-span-2">*/}
              {/*  <label className="form-label">Département</label>*/}
              {/*  <input*/}
              {/*    name="departement"*/}
              {/*    type="text"*/}
              {/*    className="form-input hover:cursor-not-allowed"*/}
              {/*    onChange={formik.handleChange}*/}
              {/*    onBlur={formik.handleBlur}*/}
              {/*    value={formik.values.departement}*/}
              {/*    disabled={true}*/}
              {/*    readOnly={true}*/}
              {/*  />*/}
              {/*  {formik.errors.departement ? <div className="text-xs text-red-600">*/}
              {/*    {formik.errors.departement}*/}
              {/*  </div> : null}*/}
              {/*</div>*/}
              <div>
                <label className="form-label">Code Postal</label>
                <input
                  name="cp"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.cp}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.cp ? <div className="text-xs text-red-600">
                  {formik.errors.cp}
                </div> : null}
              </div>
              <div>
                <label className="form-label">Ville</label>
                <input
                  name="ville"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ville}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.ville ? <div className="text-xs text-red-600">
                  {formik.errors.ville}
                </div> : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/*<div className="fixed bottom-0 left-60 right-0 bg-white border-t border-gray-200 py-3 px-4 z-30">*/}
      {/*  <div className="max-w-[1600px] mx-auto flex items-center justify-between">*/}
      {/*    <div className="flex items-center gap-3">*/}
      {/*      <span*/}
      {/*        onClick={() => setIsActive('proprietaire')}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        <IconChevronLeft className="w-4 h-4"/>*/}
      {/*        Précédent*/}
      {/*      </span>*/}
      {/*      <span*/}
      {/*        onClick={() => setIsActive('enlevement')}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Suivant*/}
      {/*        <IconChevronRight className="w-4 h-4"/>*/}
      {/*      </span>*/}
      {/*    </div>*/}
      {/*    <div className="flex items-center gap-2">*/}
      {/*      <span*/}
      {/*        onClick={() => formik.resetForm()}*/}
      {/*        className="px-3 py-1.5 border border-gray-300 rounded-lg text-gray-700 text-sm font-medium hover:bg-gray-50 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Annuler*/}
      {/*      </span>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(true)}*/}
      {/*        className="px-3 py-1.5 bg-gray-800 text-white rounded-lg text-sm font-medium hover:bg-gray-900 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isBrouillonLoading) && <IconSpinner className="animate-spin w-4 h-4"/>}*/}
      {/*        {(isBrouillonLoading) ? 'Enregistrement' : 'Brouillon'}*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(false)}*/}
      {/*        className="px-4 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isValideLoading) ? <IconSpinner className="animate-spin w-4 h-4"/> : <IconCheck className="w-4 h-4"/>}*/}
      {/*        {(isValideLoading) ? 'Enregistrement' : 'Valider'}*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*</form>*/}
    </>
  );
}

export default DepositaireForm;